import metatagImage from 'assets/images/metatagimage_1x.webp'
import React from 'react'
import { Helmet } from 'react-helmet-async'

interface PageHelmetProps {
  url: string
  description?: string
  title?: string
}

const PageHelmet = ({ description, title, url }: PageHelmetProps) => (
  <Helmet>
    <title>{title ?? 'Joepegs | Leading NFT Marketplace'}</title>
    <meta
      name="description"
      content={
        description ??
        'Dive into Joepegs, the leading Web3 platform for NFTs and digital collectibles. As a cultural hub in the Web3 space, we offer secure buying, selling, and discovery of innovative digital assets.'
      }
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={`https://joepegs.com/${url}`} />
    <meta
      property="og:title"
      content={title ?? 'Joepegs | Leading NFT Marketplace'}
    />
    <meta
      property="og:description"
      content={
        description ??
        'Dive into Joepegs, the leading Web3 platform for NFTs and digital collectibles. As a cultural hub in the Web3 space, we offer secure buying, selling, and discovery of innovative digital assets.'
      }
    />
    <meta property="og:image" content={metatagImage} />
    <meta property="twitter:card" content={metatagImage} />
    <meta property="twitter:url" content={`https://joepegs.com/${url}`} />
    <meta
      property="twitter:title"
      content={title ?? 'Joepegs | Leading NFT Marketplace'}
    />
    <meta
      property="twitter:description"
      content={
        description ??
        'Dive into Joepegs, the leading Web3 platform for NFTs and digital collectibles. As a cultural hub in the Web3 space, we offer secure buying, selling, and discovery of innovative digital assets.'
      }
    />
    <meta property="twitter:image" content={metatagImage} />
  </Helmet>
)

export default PageHelmet
